import { createAndAddGenericElement } from './generics.js'

const createCopyrightAndCreatorSection = (copyrightAndCreatorSection, copyrightAndCreatersJson) => {
    const copyrightAndCreatorDiv = createAndAddGenericElement(["text-white", "mb-0", "mt-3", "pt-3", "text-center"], "", copyrightAndCreatorSection, "", "div")
    copyrightAndCreatorDiv.setAttribute("style", "border-top: 1px solid #464646;")
    createAndAddGenericElement(["copyright-inline-left"], "", copyrightAndCreatorDiv, `Copyright &copy; ${new Date().getFullYear()}. All rights reserved.`, "div")
    createAndAddGenericElement(["copyright-inline-right"], "", copyrightAndCreatorDiv, "Powered by: <a class='text-white btn btn-link' target='_blank' href='https://claricesystems.com/'>Clarice Systems</a>", "div")
}

export { createCopyrightAndCreatorSection }